import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class StoreStateService {
  private storeIdKey = 'selectedStoreId';
  private storeFlagKey = 'isKisnaStoreAdmin';

  private _storeIdSubject = new BehaviorSubject<number | null>(null);
  private _storeFlagSubject = new BehaviorSubject<boolean | null>(null);

  public storeId$ = this._storeIdSubject.asObservable();
  public storeFlag$ = this._storeFlagSubject.asObservable();

  constructor() {
    const storedId = localStorage.getItem(this.storeIdKey);
    const storedFlag = localStorage.getItem(this.storeFlagKey);

    this._storeIdSubject.next(storedId ? +storedId : null);
    this._storeFlagSubject.next(storedFlag !== null ? storedFlag === 'true' : null);
  }

  setStoreId(id: number) {
    localStorage.setItem(this.storeIdKey, `${id}`);
    this._storeIdSubject.next(id);
  }

  setStoreFlag(flag: boolean) {
    localStorage.setItem(this.storeFlagKey, `${flag}`);
    this._storeFlagSubject.next(flag);
  }

  setStoreIdAndFlag(id: number, flag: boolean) {
    this.setStoreId(id);
    this.setStoreFlag(flag);
  }

  getStoreId(): number | null {
    return this._storeIdSubject.getValue();
  }

  getStoreFlag(): boolean | null {
    return this._storeFlagSubject.getValue();
  }

  clearStore() {
    localStorage.removeItem(this.storeIdKey);
    localStorage.removeItem(this.storeFlagKey);
    this._storeIdSubject.next(null);
    this._storeFlagSubject.next(null);
  }
}
